<template>
  <b-container>
    <div v-if="release == null">
      <span>{{ errorMsg }}</span>
    </div>
    <div v-if="release != null">
      <b-row
        ><b-col md="10"
          ><h1>{{ release.app }} Version: {{ release.version }}</h1>
          <span
            >Uploaded on {{ new Date(release.date).toLocaleString() }}</span
          ></b-col
        >
        <b-col md="2" align-self="end"
          ><router-link :to="{ name: 'Home' }" tag="b-button"
            >Back</router-link
          ></b-col
        >
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <h4>Available for:</h4>
          <b-list-group horizontal="true">
            <b-list-group-item
              v-for="browser in release.browsers"
              :key="browser"
              :href="
                baseURL +
                '/api/2.0/release/' +
                release.app +
                '/' +
                release.version +
                '?browser=' +
                browser
              "
            >
              <span>
                <font-awesome-icon
                  v-if="browser !== 'default'"
                  :icon="['fab', browser]"
                ></font-awesome-icon>
                <font-awesome-icon
                  v-else
                  icon="file-archive"
                ></font-awesome-icon>
              </span>
              <span class="ml-4">
                Download Version {{ release.version }} for {{ browser }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col md="6"> </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-button @click="openForm()">Upload file</b-button>
        </b-col>
      </b-row>
      <div class="mt-4" v-if="this.show">
        <b-row>
          <b-col md="4">
            <b-form @reset="onReset">
              <b-form-group md="2" id="group-1" label="Browser:" label-for="browser-select-form">
                <b-form-select
                v-model="browser"
                v-on:change="getBrowser(browser)"
                  id="browser-select-form"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  :options=this.browsers
                  :value="null"
                  :state="Boolean(file)"
                >
                </b-form-select>
              </b-form-group>
              <b-form-group md="4" id="group-2" label="File:" label-for="browser-file-form" v-if="fileFormActive">
                <b-form-file
                id="browser-file-form"
                  v-model="file"
                  :placeholder="this.placeholder"
                  :accept="this.browser"
                ></b-form-file>
                <div class="mt-3">Selected file: {{ file ? file.name: "no file selected!" }}</div>
              </b-form-group>
              <b-button @click="onSubmit()" class="mr-3" variant="primary">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2"> </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "ReleaseInspectorView",
  data() {
    return {
      release: null,
      browser: null,
      errorMsg: "Loading release from server...",
      baseURL: process.env.VUE_APP_API,
      show: false,
      file: null,
      fileFormActive: false,
      mimeType: null,
      placeholder: "Choose a file or drop here...",
      browsers: [{text: "Choose...", value: null}, 
        {text: "Firefox", value: ".xpi"}, 
        {text: "Chrome", value: ".crx"}, 
        {text:"Default", value:".zip"}
      ],
      getBrowser(filetype) {
        this.file =  null;
        switch(filetype) {
          case ".xpi":
            this.fileFormActive=true;
            this.placeholder="Choose a .xpi file or drop here...";
            this.mimeType = "application/x-xpinstall"
            break;
          case ".crx":
            this.fileFormActive=true;
            this.placeholder="Choose a .crx file or drop here...";
            this.mimeType = "application/x-chrome-extension"
            break;
          case ".zip": 
          this.fileFormActive=true;
          this.placeholder="Choose a .zip file or drop here...";
          this.mimeType = "application/zip"
            break;
          default:
            this.fileFormActive=false;
            this.placeholder="Choose a file or drop here...";
            break;
        }
      }
    };
  },
  watch: {
    $route(to, from) {
      //to, from
      console.log(
        "Internal navigation, take care that lifecylemehtods are not called in this case. " +
          from +
          " -> " +
          to
      );
    },
  },
  created() {
    fetch(
      `/web/releases?app=${this.$route.params.app}&version=${this.$route.params.version}`
    )
      .then((body) => body.json())
      .then((data) => {
        if (data.length === 0) this.errorMsg = "This release does not exist";
        this.release = data[0];
      });
  },
  methods: {
    openForm() {
      this.show = true;
    },
    onSubmit() {
      if(this.file !== null) {
        const data = new FormData()
        data.mimeType = this.mimeType;
        data.append('file', this.file, this.file.name);
        fetch(`/api/2.0/release/${this.release.app}/${this.release.version}`, { 
          method: "PUT", 
          body: data,
          }).then(response => {
          if(response.status == 200) {
            alert("Upload succeded!");
            this.onReset();
          } else {
            alert("Upload failed! Wrong or missing file was uploaded.")
          }
          
        }, reason => {
          alert("Error: "+ reason);
        })
        
      }
    },
    onReset() {
      this.show = false;
      this.file = null;
      this.browser = null;
      this.fileFormActive = false;
    },
  },
};
</script>

<style scoped>
</style>